export default __webpack_public_path__ + "static/hkgrotesk-boldlegacy-webfont-364bf7864053297452f0c60f5e291870.woff";